import { State as StateEnum } from '@/features/orders/constants/app'

export const statePillToneMap: Record<StateEnum, 'success' | 'warning' | 'destructive'> = {
    [StateEnum.Accepted]: 'success',
    [StateEnum.Delivering]: 'success',
    [StateEnum.Delivered]: 'success',
    [StateEnum.AwaitingAcceptance]: 'warning',
    [StateEnum.Production]: 'warning',
    [StateEnum.Ready]: 'warning',
    [StateEnum.Cancelled]: 'destructive',
}
